import React, {useMemo, KeyboardEvent} from 'react';
import direction from '../../styles/direction.module.scss';
import {isLtrStyle} from '../../utils/direction';
import {StringInputProps} from './StringInput';
import {keys} from '../../../../constants/KeyCodes';

export const TextInput = ({
    column,
    value,
    handleMouseDown,
    handleChange,
    handleKeyDown,
    inputRef,
    isReadonly,
    onFocus,
    onBlur
}: StringInputProps) => {
    const isLtr = useMemo(() => isLtrStyle(value, column.Type), [value, column]);

    const processKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (!isReadonly) {
            if ((event.key === keys.MINUS || event.key === keys.PLUS) && column.DefaultValue) {
                event.preventDefault();
                handleChange(column.DefaultValue);
            }
        }
        handleKeyDown(event);
    };

    return (
        <input
            dir={isLtr ? 'ltr' : 'rtl'}
            type={'text'}
            maxLength={column.maxLength}
            ref={inputRef}
            value={value}
            onKeyDown={processKeyDown}
            onChange={e => handleChange(e.target.value)}
            readOnly={isReadonly}
            onMouseDown={handleMouseDown}
            className={isLtr ? direction.ltrDirection : direction.rtlDirection}
            onFocus={onFocus}
            onBlur={onBlur}
        />
    );
};
